(function () {
  var instagramScriptPromise = null;

  function loadInstagramEmbeds() {
    if (window.instgrm && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === 'function') {
      return Promise.resolve(window.instgrm);
    }

    if (instagramScriptPromise) return instagramScriptPromise;

    instagramScriptPromise = new Promise(function (resolve, reject) {
      var existingScript = document.getElementById('grt-instagram-embed-script');

      if (existingScript) {
        existingScript.addEventListener('load', function () {
          resolve(window.instgrm);
        });
        existingScript.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.id = 'grt-instagram-embed-script';
      script.async = true;
      script.src = 'https://www.instagram.com/embed.js';
      script.onload = function () {
        resolve(window.instgrm);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return instagramScriptPromise;
  }

  function processInstagramEmbeds(root) {
    if (!root.querySelector('[data-grt-instagram-embed]')) return;

    loadInstagramEmbeds()
      .then(function (instgrm) {
        if (instgrm && instgrm.Embeds && typeof instgrm.Embeds.process === 'function') {
          instgrm.Embeds.process();
        }
      })
      .catch(function () {});
  }

  function setVideoPlayback(video, shouldPlay) {
    if (!video) return;

    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');

    if (shouldPlay) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
      return;
    }

    video.pause();
  }

  function mountSection(root) {
    var viewport = root.querySelector('[data-grt-reel-viewport]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-grt-reel-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-grt-reel-dot]'));
    var sectionInViewport = false;
    var cleanupHandlers = [];

    if (!viewport || !cards.length) return;

    processInstagramEmbeds(root);

    function updateDots(activeIndex) {
      if (!dots.length) return;

      dots.forEach(function (dot, index) {
        var isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function getActiveIndex() {
      var viewportStart = viewport.scrollLeft;
      var activeIndex = 0;
      var smallestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - viewportStart);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function syncDots() {
      updateDots(getActiveIndex());
    }

    function syncPlayback() {
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        var cardVisible = card.dataset.grtReelVisible === 'true';
        setVideoPlayback(video, !document.hidden && sectionInViewport && cardVisible);
      });
    }

    var sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          sectionInViewport = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        });
        syncPlayback();
      },
      {
        threshold: [0, 0.2, 0.45]
      }
    );

    var cardObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.dataset.grtReelVisible = entry.isIntersecting && entry.intersectionRatio >= 0.6 ? 'true' : 'false';
        });
        syncPlayback();
      },
      {
        root: viewport,
        threshold: [0.2, 0.6, 0.9]
      }
    );

    sectionObserver.observe(root);
    cards.forEach(function (card) {
      card.dataset.grtReelVisible = 'false';
      cardObserver.observe(card);

      var video = card.querySelector('video');
      if (!video) return;

      var handleCanPlay = function () {
        syncPlayback();
      };

      video.addEventListener('canplay', handleCanPlay);
        cleanupHandlers.push(function () {
        video.removeEventListener('canplay', handleCanPlay);
      });
    });

    dots.forEach(function (dot) {
      var handleClick = function () {
        var targetIndex = parseInt(dot.getAttribute('data-grt-reel-index') || '0', 10);
        var targetCard = cards[targetIndex];
        if (!targetCard) return;

        viewport.scrollTo({
          left: targetCard.offsetLeft,
          behavior: 'smooth'
        });
        updateDots(targetIndex);
      };

      dot.addEventListener('click', handleClick);
      cleanupHandlers.push(function () {
        dot.removeEventListener('click', handleClick);
      });
    });

    var handleViewportScroll = function () {
      syncDots();
    };

    viewport.addEventListener('scroll', handleViewportScroll, { passive: true });
    cleanupHandlers.push(function () {
      viewport.removeEventListener('scroll', handleViewportScroll);
    });

    var handleResize = function () {
      syncDots();
      syncPlayback();
    };

    window.addEventListener('resize', handleResize);
    cleanupHandlers.push(function () {
      window.removeEventListener('resize', handleResize);
    });

    var handleVisibilityChange = function () {
      syncPlayback();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    syncDots();

    root._grtReelCleanup = function () {
      sectionObserver.disconnect();
      cardObserver.disconnect();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      cleanupHandlers.forEach(function (cleanup) {
        cleanup();
      });
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        setVideoPlayback(video, false);
        delete card.dataset.grtReelVisible;
      });
    };
  }

  function initSection(root) {
    if (!root || root.dataset.grtReelReady === 'true') return;
    root.dataset.grtReelReady = 'true';
    mountSection(root);
  }

  function destroySection(root) {
    if (!root) return;
    if (typeof root._grtReelCleanup === 'function') {
      root._grtReelCleanup();
      delete root._grtReelCleanup;
    }
    delete root.dataset.grtReelReady;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-grt-reel-section]');
    Array.prototype.forEach.call(roots, initSection);
  }

  function destroyAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-grt-reel-section]');
    Array.prototype.forEach.call(roots, destroySection);
  }

  window.addEventListener('load', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    destroyAll(event.target);
  });
})();
